import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import client from "../lib/api";
import { Crest, Loading, Card, Pill } from "../components/common";
import { AdSlot } from "../components/AdSlot";

function SheetCol({ sheet, name, slug }) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-3"><Crest slug={slug} name={name} size={28} /><span className="font-head font-bold text-green">{name}</span></div>
      {sheet ? (
        <>
          <Pill tone={sheet.status === "confirmed" ? "confirmed" : "unconfirmed"}>{sheet.status}</Pill>
          <div className="text-[11px] uppercase tracking-wider text-green font-bold mt-3 mb-1">Starting XI</div>
          <ol className="space-y-0.5 text-sm">{sheet.starting_xi.map((p, i) => <li key={i} className="text-ink/80 tabular"><span className="text-ink/40 mr-2">{i + 1}.</span>{p}</li>)}</ol>
          {sheet.bench?.length > 0 && <><div className="text-[11px] uppercase tracking-wider text-ink/50 font-bold mt-3 mb-1">Bench</div><ol className="space-y-0.5 text-sm text-ink/60">{sheet.bench.map((p, i) => <li key={i}>{p}</li>)}</ol></>}
        </>
      ) : <p className="text-sm text-ink/40">Sheet not submitted.</p>}
    </div>
  );
}

export default function MatchPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); client.get(`/fixtures/${id}`).then((r) => setData(r.data)).catch(() => setData(false)); }, [id]);
  if (data === null) return <Loading />;
  if (!data) return <div className="py-20 text-center">Match not found.</div>;
  const { fixture: f, sheets } = data;
  const homeSheet = sheets.find((s) => s.club_slug === f.home_slug);
  const awaySheet = sheets.find((s) => s.club_slug === f.away_slug);
  return (
    <div data-testid="match-page" className="space-y-6">
      <Card className="p-6 bg-green text-cream border-green">
        <div className="text-center text-cream/60 text-xs uppercase tracking-widest mb-4">Matchweek {f.matchweek} · {f.venue}</div>
        <div className="flex items-center justify-center gap-6">
          <div className="flex-1 flex flex-col items-center gap-2"><Crest slug={f.home_slug} name={f.home_name} size={56} /><span className="font-head font-bold text-center">{f.home_name}</span></div>
          <div className="font-head font-black text-4xl md:text-5xl text-gold tabular">{f.status === "FT" ? `${f.home_score} - ${f.away_score}` : "vs"}</div>
          <div className="flex-1 flex flex-col items-center gap-2"><Crest slug={f.away_slug} name={f.away_name} size={56} /><span className="font-head font-bold text-center">{f.away_name}</span></div>
        </div>
        <div className="text-center mt-4">{f.status === "FT" ? <Pill tone="gold">Full time</Pill> : <span className="text-cream/70 text-sm">{new Date(f.kickoff).toLocaleString("en-GB")}</span>}</div>
      </Card>
      <AdSlot id="masthead.leaderboard" height={90} />
      <div>
        <h2 className="font-head font-black text-2xl text-green mb-4">Team sheets</h2>
        <Card className="p-6 grid grid-cols-2 gap-8">
          <SheetCol sheet={homeSheet} name={f.home_name} slug={f.home_slug} />
          <SheetCol sheet={awaySheet} name={f.away_name} slug={f.away_slug} />
        </Card>
      </div>
    </div>
  );
}
